import type { Shadows, ThemeOptions } from '@mui/material'
import { alpha } from '@mui/material'

import { createConfiguratorTheme, desktopStyles } from '@salsita-ai/platform-project-sdk/ui'

const { shadows: defaultShadows } = createConfiguratorTheme()

// Replace shadows[1–23] with `none` value.
// Keep shadows[0] ("none") and shadows[24] (Dialog).
const shadows = [defaultShadows[0], ...Array(23).fill('none'), defaultShadows[24]] as Shadows

const themeOptions = {
  components: {
    // ////////////////////////////////////////
    // Phoenix
    // ////////////////////////////////////////

    PhxCardSelectorItem: {
      styleOverrides: {
        image: {
          objectFit: 'cover',
        },
      },
    },

    PhxSidebarFooterButton: {
      defaultProps: {
        color: 'secondary',
      },
    },

    PhxSwatchSelectorItem: {
      defaultProps: {
        variant: 'square',
      },
    },

    PhxTabNavigation: {
      defaultProps: {
        variant: 'rounded',
      },
      styleOverrides: {
        tab: {
          borderRadius: 4,
        },
      },
    },

    // ////////////////////////////////////////
    // Phoenix.Desktop
    // ////////////////////////////////////////

    PhxDesktopBrandingHeader: {
      defaultProps: {
        imageAlt: 'Digital Crafter logo',
        imageHeight: 24,
        imageUrl: '/logo-digital-crafter.svg',
      },
    },

    PhxDesktopSidebar: {
      defaultProps: {
        filter: 'none',
      },
      styleOverrides: {
        tabs: {
          maxInlineSize: 'none',
        },
      },
    },

    // ////////////////////////////////////////
    // Phoenix.Mobile
    // ////////////////////////////////////////

    PhxMobileBrandingHeader: {
      defaultProps: {
        imageAlt: 'Digital Crafter logo',
        imageHeight: 20,
        imageUrl: '/logo-digital-crafter.svg',
      },
    },
  },

  // ---------------------------------------------------------------------------
  palette: {
    background: {
      default: '#EFEFEF',
      scene: '#EFEFEF',
    },

    primary: {
      main: alpha('#000', 0.87),
      dark: alpha('#000', 1.0),
      light: alpha('#000', 0.6),
    },
    secondary: {
      main: '#798e6f',
    },
  },

  shadows,

  // ---------------------------------------------------------------------------
  shape: {
    borderRadius: 0,
  },

  // ---------------------------------------------------------------------------
  typography: {
    fontFamily: '"Inter Variable", sans-serif',

    h5: {
      ...desktopStyles({
        fontSize: '1.375rem',
      }),
    },
    h6: {
      ...desktopStyles({
        fontSize: '1.125rem',
      }),
    },
  },
} as ThemeOptions // FIXME: https://salsita.atlassian.net/browse/CON-2210

export const elementTheme = createConfiguratorTheme(themeOptions)
